import { cn } from "@/utils/cn"
import * as React from "react"
import { Skeleton } from "./skeleton";

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  loading?: boolean;
  chart?: boolean;
}

const Card = React.forwardRef<
  HTMLDivElement,
  CardProps
>(({ loading, chart, className, ...props }, ref) => {
  let heightChart = 'h-80';

  let height = chart ? heightChart : '';

  if (loading && chart){
    return (
      <div
        ref={ref}
        className={cn(
          `rounded-lg border bg-card text-card-foreground shadow ${height}`,
          className
        )}>
        <CardHeader>
          <Skeleton className="h-6 w-full rounded-xl" />
        </CardHeader>
        <CardContent className="flex-1">
          <Skeleton className="h-48 w-full rounded-xl" />
        </CardContent>
      </div>
    )
  }

  return (
    <div
      ref={ref}
      className={cn(
        `rounded-lg border bg-card text-card-foreground shadow ${height}`,
        className
      )}
      {...props}
    />
  )
})

Card.displayName = "Card"

const CardHeader = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex flex-col space-y-1.5 p-6", className)}
    {...props}
  />
))
CardHeader.displayName = "CardHeader"

const CardTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  // eslint-disable-next-line
  <h3
    ref={ref}
    className={cn("font-semibold leading-none tracking-tight", className)}
    {...props}
  />
))
CardTitle.displayName = "CardTitle"

const CardDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn("text-sm text-muted-foreground", className)}
    {...props}
  />
))
CardDescription.displayName = "CardDescription"

const CardContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("p-6 pt-0", className)} {...props} />
))
CardContent.displayName = "CardContent"

const CardFooter = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex items-center p-6 pt-0", className)}
    {...props}
  />
))
CardFooter.displayName = "CardFooter"

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }
